import { gql, TypedDocumentNode } from "@apollo/client";

import { Maybe, Module, PullRequest, QueryModuleArgs, Run } from "types/generated";

export type ModulePullRequestsTableRunRow = Pick<
  Run,
  "id" | "state" | "title" | "createdAt" | "expectFailure" | "delta" | "runtimeConfig"
>;

export type ModulePullRequestsTableRow = Pick<
  PullRequest,
  | "id"
  | "authorLogin"
  | "createdAt"
  | "headBranch"
  | "headBranchURL"
  | "title"
  | "updatedAt"
  | "url"
> & {
  runs: ModulePullRequestsTableRunRow[];
};

type ListModulePullRequestsData = {
  module: Maybe<Pick<Module, "id"> & { pullRequests: ModulePullRequestsTableRow[] }>;
};

export const LIST_MODULE_PULL_REQUESTS: TypedDocumentNode<
  ListModulePullRequestsData,
  QueryModuleArgs
> = gql`
  query GetModulePullRequests($id: ID!) {
    module(id: $id) {
      id
      pullRequests {
        id
        authorLogin
        createdAt
        headBranch
        headBranchURL
        title
        updatedAt
        url
        runs {
          id
          createdAt
          delta {
            addCount
            changeCount
            deleteCount
            resources
            importCount
            forgetCount
            moveCount
            ignoreCount
            okCount
            rescueCount
            skipCount
            unreachableCount
            failedCount
          }
          expectFailure
          runtimeConfig {
            terraform {
              version
            }
          }
          state
          title
        }
      }
    }
  }
`;
